var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c("header-tabs", { attrs: { active: _vm.$route.path } }),
      _vm._v(" "),
      _c("el-row", { staticClass: "filter" }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "80%",
              margin: "0 auto",
              "margin-top": "20px",
              "margin-bottom": "20px"
            }
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "demo-ruleForm",
                attrs: { model: _vm.form, "label-width": "160px" }
              },
              [
                _c("p", [_vm._v("自动化汇总")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "商品数量/波次：", prop: "order_goods_num" }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "25%", float: "left" },
                      attrs: { type: "number", disabled: "" },
                      model: {
                        value: _vm.form.auto_min,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "auto_min", $$v)
                        },
                        expression: "form.auto_min"
                      }
                    }),
                    _vm._v("~\n          "),
                    _c("el-input", {
                      staticStyle: { width: "25%" },
                      attrs: { type: "number" },
                      on: { change: _vm.set_many_nin },
                      model: {
                        value: _vm.form.auto_max,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "auto_max", $$v)
                        },
                        expression: "form.auto_max"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "波次汇总数量 ：", prop: "summary_num" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "50%" },
                      attrs: { type: "number" },
                      model: {
                        value: _vm.form.auto_num,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "auto_num", $$v)
                        },
                        expression: "form.auto_num"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [_vm._v("多件多波汇总")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "商品数量/波次：", prop: "order_goods_num" }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "25%", float: "left" },
                      attrs: { type: "number", disabled: "" },
                      model: {
                        value: _vm.form.many_min,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "many_min", $$v)
                        },
                        expression: "form.many_min"
                      }
                    }),
                    _vm._v("~\n          "),
                    _c("el-input", {
                      staticStyle: { width: "25%" },
                      attrs: { type: "number" },
                      model: {
                        value: _vm.form.many_max,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "many_max", $$v)
                        },
                        expression: "form.many_max"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "波次汇总数量 ：", prop: "summary_num" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "50%" },
                      attrs: { type: "number" },
                      model: {
                        value: _vm.form.many_num,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "many_num", $$v)
                        },
                        expression: "form.many_num"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [_vm._v("提前汇总设置")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "波次数量 ：", prop: "temp_summary_num" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "50%" },
                      attrs: { type: "number" },
                      model: {
                        value: _vm.form.temp_summary_num,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "temp_summary_num", $$v)
                        },
                        expression: "form.temp_summary_num"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onSubmit }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("el-row")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00d80a56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00d80a56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/SummarySetting.vue
// module id = null
// module chunks = 